import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * A semantic group of form controls: a `<fieldset>` without a surface. It
 * disables every control inside it at once (`disabled`) and names the group
 * with a `<legend>` child. For a titled, visual form group use `FormSection`
 * (dashboard) or `DomainSection as="fieldset"`; this primitive only owns the
 * element and its reset (`min-w-0`, so a fieldset never forces min-content
 * width on its grid or flex parent).
 */
const FieldGroup = React.forwardRef<
  HTMLFieldSetElement,
  React.FieldsetHTMLAttributes<HTMLFieldSetElement>
>(({ className, ...props }, ref) => (
  <fieldset ref={ref} className={cn("min-w-0", className)} {...props} />
));
FieldGroup.displayName = "FieldGroup";

/** The group's name, in the form-label typography (same as `Label`). */
const FieldGroupLegend = React.forwardRef<
  HTMLLegendElement,
  React.HTMLAttributes<HTMLLegendElement>
>(({ className, ...props }, ref) => (
  <legend
    ref={ref}
    className={cn("text-sm font-medium leading-none", className)}
    {...props}
  />
));
FieldGroupLegend.displayName = "FieldGroupLegend";

export { FieldGroup, FieldGroupLegend };
